// AUTO-GENERATED SQL Builder (V40 Final) for BookingSchedule
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingScheduleSql {
  private ast = new SqlAst('BookingSchedule', 'bookingSchedule');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public seq: SqlField;
  public label: SqlField;
  public mode: SqlField;
  public value: SqlField;
  public dueDate: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public paymentList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingSchedule', 'guid', '', 'id', 'bookingSchedule_guid');
    this.bookingId = new SqlField('bookingSchedule', 'bookingId', 'booking', 'id', 'bookingSchedule_booking');
    this.seq = new SqlField('bookingSchedule', 'seq', '', 'id', 'bookingSchedule_seq');
    this.label = new SqlField('bookingSchedule', 'label', '', 'id', 'bookingSchedule_label');
    this.mode = new SqlField('bookingSchedule', 'mode', '', 'id', 'bookingSchedule_mode');
    this.value = new SqlField('bookingSchedule', 'value', '', 'id', 'bookingSchedule_value');
    this.dueDate = new SqlField('bookingSchedule', 'dueDate', '', 'id', 'bookingSchedule_dueDate');
    this.booking = createNavHybrid('bookingSchedule', 'bookingSchedule_booking', 'Booking');
    this.createdByUser = createNavHybrid('bookingSchedule', 'bookingSchedule_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('bookingSchedule', 'bookingSchedule_updatedByUser', 'User');
    this.paymentList = createNavHybrid('bookingSchedule', 'bookingSchedule_paymentList', 'Payment');
    this.id = new SqlField('bookingSchedule', 'id', '', 'id', 'bookingSchedule_id');
    this.isDeleted = new SqlField('bookingSchedule', 'isDeleted', '', 'id', 'bookingSchedule_isDeleted');
    this.createdBy = new SqlField('bookingSchedule', 'createdBy', '', 'id', 'bookingSchedule_createdBy');
    this.createdDate = new SqlField('bookingSchedule', 'createdDate', '', 'id', 'bookingSchedule_createdDate');
    this.updatedBy = new SqlField('bookingSchedule', 'updatedBy', '', 'id', 'bookingSchedule_updatedBy');
    this.updatedDate = new SqlField('bookingSchedule', 'updatedDate', '', 'id', 'bookingSchedule_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingScheduleSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingScheduleSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingScheduleSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingScheduleSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingScheduleSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingScheduleSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingScheduleSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingScheduleSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingScheduleSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingScheduleSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
